/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IEveFormInput contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum fieldwidth {
    fullWidth = 'fullWidth',
    halfWidth = 'halfWidth',
    thirdWidth = 'thirdWidth',
    twoThirdWidth = 'twoThirdWidth'
}

export interface IEveFormInputConfig extends Msdyn365.IModuleConfig {
    friendlyName?: string;
    name?: string;
    validation?: IValidationData;
    placeholder?: string;
    istextarea?: boolean;
    rows?: number;
    characterlimit?: number;
    fieldwidth?: fieldwidth;
    defaultvalue?: string;
}

export interface IEveFormInputResources {
    defaultError: string;
    charactersRemaining: string;
}

export interface IValidationData {
    regex?: string;
    errorMessage?: string;
    isRequiredValidation?: boolean;
}

export interface IEveFormInputProps<T> extends Msdyn365.IModule<T> {
    resources: IEveFormInputResources;
    config: IEveFormInputConfig;
}
